/** How many definitions the store seed and each picker search read (P7-R35, FU-LBLDEF). */
const LABEL_DEFINITION_PAGE_SIZE = 50;

/** The pickers' order: by name, so the seed is the alphabetical head of the organization's labels. */
const BY_LABEL = [{ field: 'label', sort: 'asc' }];

/** One page of definitions by name; `searchText` narrows them on the server (any word, case-insensitive). */
export const labelDefinitionPageInput = (searchText = '') => ({
  first: LABEL_DEFINITION_PAGE_SIZE,
  sortItems: BY_LABEL,
  ...(searchText ? { searchText } : {}),
});

/**
 * The definitions store seed: the first page of the organization's labels for the store's types, by name. The
 * operation name, the `{ types }` variables and this document's identity are a contract: accounting's journal-entry
 * submit refetches `GetDefinitions` by document. The page input stays inline so those variables never change.
 */
const GetDefinitions = gql`
  query LabelDefinitionsQuery($types: [LabelType!]) {
    labelDefinitionPage(input: { first: 50, sortItems: [{ field: "label", sort: "asc" }] }, types: $types) {
      totalCount
      edges {
        node {
          id
          label
          description
          color
          labelTypes
        }
      }
    }
  }
`;

/** The add-label picker's server search: any label past the seed is found by typing its name. */
const SearchDefinitions = gql`
  query LabelDefinitionOptionsQuery($types: [LabelType!], $input: StandardPageInput!) {
    labelDefinitionPage(input: $input, types: $types) {
      edges {
        node {
          id
          label
          description
          color
          labelTypes
        }
      }
    }
  }
`;

const GetAttachedLabels = gql`
  query LabelAttachmentsQuery($attachedTo: LabelsAttachableTo!) {
    labelAttachments(attachedTo: $attachedTo, take: 78000) {
      id
      labelDefinition {
        id
        label
        description
        color
        labelTypes
      }
    }
  }
`;

const CreateAndAttachLabels = gql`
  mutation CreateAndAttachLabels($input: CreateAndAttachLabelsInput!) {
    createAndAttachLabels(input: $input) {
      labelDefinitions {
        id
        label
        description
        color
        labelTypes
      }
      labelAttachments {
        id
        labelDefinition {
          id
          label
          description
          color
          labelTypes
        }
      }
    }
  }
`;

const DetachLabel = gql`
  mutation DetachLabel($id: Int!) {
    deleteLabelAttachment(id: $id)
  }
`;

const CreateManyDefinitions = gql`
  mutation CreateManyLabelDefinitions($input: CreateManyLabelsInput!) {
    createManyLabels(input: $input) {
      id
      label
      description
      color
      labelTypes
    }
  }
`;

const DeleteLabelDefinition = gql`
  mutation DeleteLabelDefinition($id: Int!) {
    deleteLabelDefinition(id: $id) {
      id
    }
  }
`;

const UpdateLabelDefinition = gql`
  mutation UpdateLabelDefinition($id: Int!, $input: UpdateLabelDefinitionInput!) {
    updateLabelDefinition(id: $id, input: $input) {
      id
    }
  }
`;

export default {
  CreateManyDefinitions,
  GetDefinitions,
  SearchDefinitions,
  GetAttachedLabels,
  CreateAndAttachLabels,
  DetachLabel,
  DeleteLabelDefinition,
  UpdateLabelDefinition,
};
